import {
    webpushManualPromptHeader,
    webpushManualPromptStep1,
    webpushManualPromptStep2,
    webpushManualPromptStep3,
    webpushManualPromptStep4,
    webpushManualPromptOK,
} from './ManuallyAllowWebPushPopup.locstring.json';
import loc from 'owa-localize';
import { completeManualNotificationPermissionsPrompt } from '../actions/manualPromptActions';
import { webPushStore } from '../store/store';
import { observer } from 'mobx-react';
import { PrimaryButton } from 'office-ui-fabric-react/lib/Button';
import { Dialog, DialogFooter } from 'office-ui-fabric-react/lib/Dialog';
import { Layer } from 'office-ui-fabric-react/lib/Layer';

import * as React from 'react';

let styles = require('./ManuallyAllowWebPushPopup.scss');

@observer
export class ManuallyAllowWebPushPopup extends React.Component<{}, {}> {
    private step = (stepDirections: string, key: number) => (
        <li className={styles.step} key={key}>
            {stepDirections}
        </li>
    );

    private steps = (steps: string[]) => <ol className={styles.steps}>{steps.map(this.step)}</ol>;

    render() {
        return (
            <Layer>
                <Dialog
                    dialogContentProps={{
                        showCloseButton: true,
                        title: loc(webpushManualPromptHeader),
                    }}
                    modalProps={{
                        isBlocking: true,
                        isDarkOverlay: true,
                        containerClassName: styles.dialogContainer,
                    }}
                    hidden={false}
                    onDismiss={this.dismiss}>
                    {this.steps([
                        loc(webpushManualPromptStep1),
                        loc(webpushManualPromptStep2),
                        loc(webpushManualPromptStep3),
                        loc(webpushManualPromptStep4),
                    ])}
                    <DialogFooter>
                        <PrimaryButton
                            onClick={this.dismiss}
                            text={loc(webpushManualPromptOK)}
                            disabled={
                                webPushStore ? webPushStore.webPushPermission === 'denied' : true
                            }
                        />
                    </DialogFooter>
                </Dialog>
            </Layer>
        );
    }

    private dismiss = () => {
        completeManualNotificationPermissionsPrompt(window.Notification.permission);
    };
}
